// extracted by mini-css-extract-plugin
export default {"container":"UserSelectItem_container__2W36d","selected":"UserSelectItem_selected__ai1Vj"};